var _rect, _rect2, _path, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMetabotSad = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 58,
  height: 43,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 56.5,
  height: 41.5,
  x: 0.75,
  y: 0.75,
  fill: "var(--illustration-secondary)",
  stroke: "var(--illustration-primary)",
  strokeWidth: 1.5,
  rx: 3.25
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 26,
  x: 7,
  y: 6,
  fill: "var(--illustration-background)",
  stroke: "var(--illustration-primary)",
  strokeWidth: 1.5,
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--illustration-primary)",
  d: "M27 23.5h-1c0-1.77 1.048-3 3-3s3 1.23 3 3h-1c0-1-.5-2-2-2s-2 1-2 2Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20.75,
  cy: 15.75,
  r: 1.75,
  fill: "var(--illustration-primary)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 36.75,
  cy: 15.75,
  r: 1.75,
  fill: "var(--illustration-primary)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.5,
  cy: 37,
  r: 1.5,
  fill: "var(--illustration-secondary)",
  stroke: "var(--illustration-primary)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 37,
  r: 1.5,
  fill: "var(--illustration-secondary)",
  stroke: "var(--illustration-primary)"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMetabotSad);
export default ForwardRef;